import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AuthRoutingModule } from './auth-routing.module';

import { LoginComponent } from './login/login.component';
import { SharedModule } from '../../shared/shared.module';
import { MaterialModule } from '../material/material.module';
import { IconsModule } from '../material/icons/icons.module';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { LayoutModule } from '../layout/layout.module';
import { LoginWithRecoveryCodeComponent } from './login-with-recovery-code/login-with-recovery-code.component';
import { SelectCustomerComponent } from './components/select-customer/select-customer.component';

@NgModule({
	imports: [
		CommonModule,
		ReactiveFormsModule,
		FormsModule,
		AuthRoutingModule,
		MaterialModule,
		IconsModule,
		SharedModule,
		LayoutModule,
	],
	declarations: [LoginComponent, ResetPasswordComponent, LoginWithRecoveryCodeComponent, SelectCustomerComponent],
})
export class AuthModule {}
